import {
	Paypal,
	Visa,
	Mastercard,
	AmericanExpress,
	Ideal,
	BancontactMisterCash,
	Sofort,
	Sepa,
	Giropay,
	Klarna,
	Diners,
	Eps,
	InvoiceSign,
} from '~/components/payment-icons'

const payments = [
	/*{
		Icon: InvoiceSign,
		label: 'advancePayment',
		type: 'advance_payment',
		region: ['global'],
		paymentMethod: 'advance_payment',
	},
	 */
	{
		Icon: Paypal,
		label: 'paypal',
		type: 'paypal',
		region: ['global'],
		paymentMethod: 'paypal',
	},
	{
		Icon: Visa,
		label: 'visa',
		type: 'card',
		region: ['global'],
		paymentMethod: 'stripe',
	},
	{
		Icon: Mastercard,
		label: 'mastercard',
		type: 'card',
		region: ['global'],
		paymentMethod: 'stripe',
	},
	{
		Icon: AmericanExpress,
		label: 'americanExpress',
		type: 'card',
		region: ['global'],
		paymentMethod: 'stripe',
	},
	{
		Icon: Diners,
		label: 'diners',
		type: 'card',
		region: ['global'],
		paymentMethod: 'stripe',
	},
	// { Icon: null,                  label: 'cartes_bancaires',       type: 'card',              region: ['europe'], paymentMethod: 'stripe' },
	// { Icon: Maestro,               label: 'maestro',                type: 'card',              region: [], paymentMethod: 'stripe' },
	// { Icon: null,                  label: 'discover',               type: 'card',              region: ['us'], paymentMethod: 'stripe' },
	// { Icon: null,                  label: 'interac',                type: 'card',              region: ['us'], paymentMethod: 'stripe' },
	// { Icon: null,                  label: 'jcb',                    type: 'card',              region: ['asia'], paymentMethod: 'stripe' },
	// { Icon: null,                  label: 'china_union_pay',        type: 'card',              region: ['asia'], paymentMethod: 'stripe' },
	// { Icon: null,                  label: 'ach_direct_debit',       type: null,                region: ['us'], paymentMethod: 'stripe' },
	// { Icon: null,                  label: 'canadian_pads',          type: null,                region: ['us'], paymentMethod: 'stripe' },
	// { Icon: null,                  label: 'bacs_direct_debit',      type: 'bacs_debit',        region: ['europe'], paymentMethod: 'stripe' },
	{
		Icon: Sepa,
		label: 'sepa',
		type: 'sepa_debit',
		region: ['europe'],
		paymentMethod: 'stripe',
	},
	// { Icon: null,                  label: 'becs_direct_debit',      type: null,                region: ['asia'], paymentMethod: 'stripe' },
	{
		Icon: BancontactMisterCash,
		label: 'bancontactMisterCash',
		type: 'bancontact',
		region: ['europe'],
		paymentMethod: 'stripe',
	},
	// { Icon: null,                  label: 'blik',                   type: 'blik',              region: ['europe'], paymentMethod: 'stripe' },
	{
		Icon: Eps,
		label: 'eps',
		type: 'eps',
		region: ['europe'],
		paymentMethod: 'stripe',
	},
  /*
	{
		Icon: Giropay,
		label: 'giroPay',
		type: 'giropay',
		region: ['europe'],
		paymentMethod: 'stripe',
	},
   */
	{
		Icon: Ideal,
		label: 'ideal',
		type: 'ideal',
		region: ['europe'],
		paymentMethod: 'stripe',
	},
	// { Icon: null,                  label: 'p24',                    type: 'p24',               region: ['europe'], paymentMethod: 'stripe' },
	{
		Icon: Sofort,
		label: 'sofort',
		type: 'sofort',
		region: ['europe'],
		paymentMethod: 'stripe',
	},
	// { Icon: null,                  label: 'fpx',                    type: null,                region: ['asia'], paymentMethod: 'stripe' },
	// { Icon: null,                  label: 'pay_now',                type: null,                region: ['asia'], paymentMethod: 'stripe' },
	// { Icon: null,                  label: 'upi',                    type: null,                region: ['asia'], paymentMethod: 'stripe' },
	// { Icon: null,                  label: 'netbanking',             type: null,                region: ['asia'], paymentMethod: 'stripe' },
	// { Icon: WechatPay,             label: 'we_chat_pay',            type: 'wechat_pay',        region: [], paymentMethod: 'stripe' },
	{
		Icon: Klarna,
		label: 'klarna',
		type: 'klarna',
		region: ['europe'],
		paymentMethod: 'stripe',
	},
	// { Icon: null,                  label: 'afterpay_clearpay',      type: 'afterpay_clearpay', region: ['europe'], paymentMethod: 'stripe' },
	// { Icon: ApplePay,              label: 'apple_pay',              type: null,                region: ['global'], paymentMethod: 'stripe' },
	// { Icon: GoogleWallet,          label: 'google_pay',             type: null,                region: ['global'], paymentMethod: 'stripe' },
	// { Icon: null,                  label: 'secure_remote_commerce', type: null,                region: ['global'], paymentMethod: 'stripe' },
	// { Icon: null,                  label: 'link',                   type: 'link',              region: ['global'], paymentMethod: 'stripe' },
	// { Icon: null,                  label: 'mobile_pay',             type: null,                region: ['europe'], paymentMethod: 'stripe' },
]

export { payments }
